<div class="label">{{ label }}</div>
<div class="code-block">
    <ng-content></ng-content>
</div>
